var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"heading":_vm.label}},[(_vm.content)?_c('span',[_vm._v(_vm._s(_vm.content))]):_c('span',[_vm._v("Welcome to "+_vm._s(_vm.$store.getters['app/appName'])+"!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }